// @material-ui/core components
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  fetchGetAddressUsingZipCode,
  fetchGetCityUsingZipCode,
  fetchGetAddressUsingCoordinates
} from "actions/datagouv";

import {
  SET_NEIGHBORHOOD_ADDRESS,
  SET_NEIGHBORHOOD_CITY,
  SET_NEIGHBORHOOD_ZIP_CODE,
  SET_NEIGHBORHOOD_SELECTED_CITY,
  SET_NEIGHBORHOOD_SELECTED_ADDRESS,
  SET_NEIGHBORHOOD_SELECTED_ZIPCODE,
  SET_NEIGHBORHOOD_BUILDING,
  SET_NEIGHBORHOOD_RESIDENCE,
  SET_NEIGHBORHOOD_DISTRICT
} from "actions/types";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle";
import CustomInput from "components/CustomInput/CustomInput";
// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  defaultFont,
  grayColor
} from "assets/jss/material-dashboard-pro-react";

const OTHER = "Autre ...";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  ...customInputStyle,
  ...customSelectStyle,
  myInputLabelStyle: {
    ...defaultFont,
    textTransform: "none",
    fontWeight: "400",
    fontSize: "14px"
  },
  grayColor: {
    color: grayColor[3] + " !important"
  }
};

class Step2 extends React.Component {
  sendState() {
    return this.state;
  }

  isValidated() {
    return true;
  }

  renderItems = data => {
    const { classes } = this.props;
    const components = [];

    if (data) {
      // eslint-disable-next-line
      for (const obj of data) {
        components.push(
          <MenuItem
            key={obj}
            classes={{
              root: classes.selectMenuItem + " " + classes.myInputLabelStyle,
              selected:
                classes.selectMenuItemSelected + " " + classes.myInputLabelStyle
            }}
            value={obj}
          >
            {obj}
          </MenuItem>
        );
      }
    }
    return components;
  };

  render() {
    const {
      classes,
      dispatch,
      customAddress,
      address,
      addresses,
      selectedAddress,
      addressUpdated,
      zipCodes,
      selectedZipCode,
      customZipCode,
      zipCode,
      zipCodeUpdated,
      cities,
      selectedCity,
      customCity,
      longitude,
      latitude,
      building,
      residence,
      district
    } = this.props;
    return (
      <GridContainer justify="center">
        {selectedAddress === OTHER ? (
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Adresse"
              id="address"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: customAddress ? customAddress : "",
                onChange: e =>
                  dispatch({
                    type: SET_NEIGHBORHOOD_ADDRESS,
                    value: e.target.value
                  }),
                onBlur: () => {
                  if (addressUpdated && address) {
                    if (zipCode) {
                      this.props.fetchGetAddressUsingZipCode({
                        address,
                        zipCode
                      });
                    } else if (longitude && latitude) {
                      this.props.fetchGetAddressUsingCoordinates({
                        address,
                        latitude,
                        longitude
                      });
                    }
                  }
                }
              }}
            />
          </GridItem>
        ) : (
          <GridItem xs={12} sm={12} md={12}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel
                htmlFor="simple-select"
                className={
                  classes.selectLabel +
                  " " +
                  classes.myInputLabelStyle +
                  " " +
                  classes.grayColor
                }
              >
                Adresse
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select + " " + classes.myInputLabelStyle
                }}
                value={selectedAddress ? selectedAddress : ""}
                onChange={(e, value) =>
                  dispatch({
                    type: SET_NEIGHBORHOOD_SELECTED_ADDRESS,
                    payload: value.props.children
                  })
                }
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select"
                }}
              >
                <MenuItem
                  classes={{
                    root:
                      classes.selectMenuItem + " " + classes.myInputLabelStyle
                  }}
                >
                  {OTHER}
                </MenuItem>
                {this.renderItems(Object.keys(addresses))}
              </Select>
            </FormControl>
          </GridItem>
        )}
        {selectedZipCode === OTHER ? (
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="Code postal"
              id="zipcode"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: customZipCode ? customZipCode : "",
                onChange: e =>
                  dispatch({
                    type: SET_NEIGHBORHOOD_ZIP_CODE,
                    value: e.target.value
                  }),
                onBlur: () =>
                  zipCodeUpdated &&
                  zipCode &&
                  this.props.fetchGetCityUsingZipCode({ address, zipCode })
              }}
            />
          </GridItem>
        ) : (
          <GridItem xs={12} sm={12} md={6}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel
                htmlFor="simple-select"
                className={
                  classes.selectLabel +
                  " " +
                  classes.myInputLabelStyle +
                  " " +
                  classes.grayColor
                }
              >
                Code postal
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select + " " + classes.myInputLabelStyle
                }}
                value={selectedZipCode ? selectedZipCode : ""}
                onChange={(e, value) =>
                  dispatch({
                    type: SET_NEIGHBORHOOD_SELECTED_ZIPCODE,
                    payload: value.props.children
                  })
                }
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select"
                }}
              >
                <MenuItem
                  classes={{
                    root:
                      classes.selectMenuItem + " " + classes.myInputLabelStyle
                  }}
                >
                  {OTHER}
                </MenuItem>
                {this.renderItems(Object.keys(zipCodes))}
              </Select>
            </FormControl>
          </GridItem>
        )}
        {selectedCity === OTHER ? (
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="Ville"
              id="city"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: customCity ? customCity : "",
                onChange: e =>
                  dispatch({
                    type: SET_NEIGHBORHOOD_CITY,
                    value: e.target.value
                  })
              }}
            />
          </GridItem>
        ) : (
          <GridItem xs={12} sm={12} md={6}>
            <FormControl fullWidth className={classes.selectFormControl}>
              <InputLabel
                htmlFor="simple-select"
                className={
                  classes.selectLabel +
                  " " +
                  classes.myInputLabelStyle +
                  " " +
                  classes.grayColor
                }
              >
                Ville
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select + " " + classes.myInputLabelStyle
                }}
                value={selectedCity ? selectedCity : ""}
                onChange={(e, value) =>
                  dispatch({
                    type: SET_NEIGHBORHOOD_SELECTED_CITY,
                    payload: value.props.children
                  })
                }
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select"
                }}
              >
                <MenuItem
                  classes={{
                    root:
                      classes.selectMenuItem + " " + classes.myInputLabelStyle
                  }}
                >
                  {OTHER}
                </MenuItem>
                {this.renderItems(Object.keys(cities))}
              </Select>
            </FormControl>
          </GridItem>
        )}
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText="Bâtiment"
            id="building"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value: building ? building : "",
              onChange: e =>
                dispatch({
                  type: SET_NEIGHBORHOOD_BUILDING,
                  value: e.target.value
                })
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <CustomInput
            labelText="Résidence"
            id="residence"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value: residence ? residence : "",
              onChange: e =>
                dispatch({
                  type: SET_NEIGHBORHOOD_RESIDENCE,
                  value: e.target.value
                })
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <CustomInput
            labelText="Quartier"
            id="district"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              value: district ? district : "",
              onChange: e =>
                dispatch({
                  type: SET_NEIGHBORHOOD_DISTRICT,
                  value: e.target.value
                })
            }}
          />
        </GridItem>
      </GridContainer>
    );
  }
}

Step2.propTypes = {
  classes: PropTypes.object
};

const mapStateToProps = state => {
  const {
    _id,
    isFetching,
    isFetchingList,
    name,
    nameErrorMsg,
    addressUpdated,
    customAddress,
    addresses,
    selectedAddress,
    address,
    customZipCode,
    zipCodes,
    selectedZipCode,
    zipCode,
    zipCodeUpdated,
    customCity,
    city,
    selectedCity,
    cities,
    latitude,
    longitude,
    registerkey,
    building,
    residence,
    district
  } = state.neighborhoodReducer;
  return {
    _id,
    isFetching,
    isFetchingList,
    name,
    nameErrorMsg,
    address,
    customAddress,
    addresses,
    selectedAddress,
    addressUpdated,
    zipCode,
    customZipCode,
    zipCodes,
    selectedZipCode,
    zipCodeUpdated,
    customCity,
    city,
    selectedCity,
    cities,
    latitude,
    longitude,
    registerkey,
    building,
    residence,
    district
  };
};

const mapDispatchToProps = dispatch => {
  let actions = bindActionCreators(
    {
      fetchGetAddressUsingZipCode,
      fetchGetCityUsingZipCode,
      fetchGetAddressUsingCoordinates
    },
    dispatch
  );
  return { ...actions, dispatch };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(style)(Step2));
